import * as React from "react"
import { View, ViewStyle, TextStyle, TouchableOpacity } from "react-native"
import { Feather, FontAwesome, MaterialIcons } from "@expo/vector-icons"
import { flatten } from "ramda"

import { color, spacing, typography } from "@app/theme"
import { IconButtonHorizontalProps } from "./icon.props"
import { Text } from "@app/components"

const CONTAINER: ViewStyle = {
  alignItems: "center",
  justifyContent: "center"
}

const ICON_TEXT: TextStyle = {
  fontFamily: typography.primary,
  fontSize: 16,
  marginTop: 2,
  color: color.palette.gray4
}

const ICON: TextStyle = {
  maxHeight: 100,
  fontSize: 18,
  width: 18,
  height: 18,
  color: color.palette.gray4,
  marginRight: spacing[2]
}
const ICON_BUTTON: ViewStyle = {
  alignItems: "center",
  padding: spacing[2],
  justifyContent: "center",
  flexBasis: 70,
  flexShrink: 1,
  minWidth: 50
}

const Icons = {
  MaterialIcons,
  FontAwesome,
  Feather
}

export const IconButtonHorizontal: React.FC<IconButtonHorizontalProps> = (props) => {
  const { name, text, lib, style, containerStyle, ...rest } = props
  const Icon = Icons[lib]
  return (
    <View style={flatten([CONTAINER, containerStyle])}>
      <TouchableOpacity style={flatten([ICON_BUTTON, style])} disabled={false} {...rest}>
        <Icon style={ICON} name={name} />
        {text && <Text style={ICON_TEXT}>{text}</Text>}
      </TouchableOpacity>
    </View>
  )
}
